import React from 'react';
import { StyledConfirmOrCancelModal } from 'src/presentation/components/pages/shared/rowActions/StyledConfirmOrCancelModal';
import { Role } from 'src/actions/roles/rolesResource';

interface RoleArchiveModalProps {
  isVisible: boolean;
  selectedRole: Role | null;
  onCancel: () => void;
  onSubmit: () => void;
}

const RoleArchiveModal: React.FC<RoleArchiveModalProps> = ({ isVisible, selectedRole, onCancel, onSubmit }) => {
  if (!isVisible || !selectedRole) {
    return null;
  }

  return (
    <StyledConfirmOrCancelModal
      confirmationText={
        selectedRole.disabledAt
          ? 'You sure you want to make this role active?'
          : 'You sure you want to archive this role?'
      }
      id={selectedRole.id}
      onCancel={onCancel}
      onSubmit={onSubmit}
      submitText={selectedRole.disabledAt ? 'Yes, make active' : 'Yes, archive'}
      text={
        <>
          You&apos;re about to {selectedRole.disabledAt ? 'make active' : 'archive'} <b>{selectedRole.name}</b>.
          {!selectedRole.disabledAt && ' This will make the role unavailable for assignment to new users.'}
        </>
      }
      title={selectedRole.disabledAt ? 'Make Role Active' : 'Archive Role'}
    />
  );
};

export default RoleArchiveModal;
